define((require) => {
    "use strict";

    const ImprovedModel  = require("shared/zbone/ImprovedModel");
    const RestApi        = require("shared/services/RestApi");
    const Permissions    = require("shared/security/Permissions");

    /**
     * JSON Example:
     *
     * ```json
     * {
     *      "id": "595657cae4b00836a8728fb2",
     *      "companyId": "55a7571de4b0e7008a500f8d",
     *      "createdAt": 1498830794356,
     *      "createdBy": "55a7571de4b0e7008a500f91",
     *      "version": 1,
     *      "name": "Arial Narrow Bold Italic",
     *      "fontFamily": "Arial Narrow Bold Italic",
     *      "format": "truetype",
     *      "path": "assets/fonts/55a7571de4b0e7008a500f8d/595657cae4b00836a8728fb2.ttf",
     *      "extension": "ttf",
     *      "timesUsed": 2,
     *      "size": 183932
     * }
     * ```
     * @class CustomFontModel
     */
    return ImprovedModel.extend("CustomFontModel", {

        url() {
            return RestApi.pathToSpecificResource(RestApi.Collections.FONTS, this.get("id"));
        },

        computed: {
            readOnly: {
                deps: ["timesUsed"],
                value(timesUsed) {
                    return Boolean(timesUsed) || Permissions.Roles.MANAGER.cannot();
                }
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/services/fonts/customFonts/CustomFontModel.js